module.exports = __webpack_public_path__ + "static/media/hard-slide1.bb2243fb.png";